import React from "react";
import Chart from "react-apexcharts";
import Cookies from "js-cookie";

function ChartJobRemain(data) {
  var setdata = [];
  var data_show = [];
  var set_result = [];
  var xaxis_categories = [];
  
  if (Cookies.get("operator_id") === "1") {
    for (let i = 0; i < data.data.length; i++) {
      setdata.push(data.data[i].summary_data);
    }
    let unique = [...new Set(setdata)];
    for (let i = 0; i < unique.length; i++) {
      const result = data.data.filter(data => data.summary_data === unique[i]);
      for (let r = 0; r < result.length; r++) {
        set_result.push(result[r].count_accum_job);
      }
      data_show.push({
        name: unique[i],
        data: set_result
      });
      set_result = [];
    }
  }
  else if (Cookies.get("operator_id") === "2" || Cookies.get("operator_id") === "3"  || Cookies.get("operator_id") === "4")  {
    var setName = [] ; 
    var setData = [] ;
    var tem_data = [] ; 

    for (let i = 0; i < data.data.length; i++) {
    for (const [key, value] of Object.entries(data.data[i])) {
      tem_data.push( {name : `${key}` , value  : `${value}`});
      setName.push(`${key}`);
      if( `${key}` === "data_list"){
        xaxis_categories.push(`${value}`);
      }
    }
    }
    let unique = [...new Set(setName)];
    for(let r = 0 ; r < unique.length ; r++){
  
      if(unique[r] != "data_list"){
        const result = tem_data.filter(data => data.name === unique[r]);
        for (const [key, value] of Object.entries(result)) {
          setData.push(value.value);
        }
        data_show.push({
          name: unique[r] , 
          data : setData , 
        });
      setData = [] ; 
      }
   
    }
  }

  const series = data_show;
  const options = {
    chart: {
      height: 450,
      type: 'line',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      },
      // yaxis: {
      //   labels: {
      //     minWidth: 40
      //   }
      // },
  
    },
        xaxis: {
        categories: xaxis_categories,
        title: {
          text: 'category'
        }
      },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: false,
      offsetY: 0,
      offsetX: 0,
      fontSize: '10px',
    },
    stroke: {
      show: true,
      curve: 'smooth',
      lineCap: 'butt',
      colors: undefined,
      width: 2,
      dashArray: 0,
    },
    title: {
      // text: 'Product Trends by Month',
      align: 'left'
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5
      },
    },

    colors: ['#1C3583', '#DD8524', '#5F7C36', '#ECC419'],

  };

  return (
    <Chart options={options} series={series} height={422} />
  )
}

export default ChartJobRemain














